export default "__VITE_ASSET__823dc220__"